import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum CandidatureAddErrorType {
  TAXI_DRIVER_ASSOCIATION_NOT_EXISTS = "TAXI_DRIVER_ASSOCIATION_NOT_EXISTS",
  TAXI_DRIVER_CONTRACT_NOT_VALID = "TAXI_DRIVER_CONTRACT_NOT_VALID",
  TAXI_RAILY_CONTRACT_NOT_VALID = "TAXI_RAILY_CONTRACT_NOT_VALID",
  ORDER_NOT_EXISTS = "ORDER_NOT_EXISTS",
  ORDER_IN_PROGRESS = "ORDER_IN_PROGRESS",
  PLAN_ENTRY_CANDIDATE_COLLISION = "PLAN_ENTRY_CANDIDATE_COLLISION",
}

export type CandidatureAddTaxiDriverAssociationNotExistsError = DataLoadError<
  CandidatureAddErrorType.TAXI_DRIVER_ASSOCIATION_NOT_EXISTS,
  {}
>;

export type CandidatureAddTaxiDriverContractNotValidError = DataLoadError<
  CandidatureAddErrorType.TAXI_DRIVER_CONTRACT_NOT_VALID,
  {}
>;

export type CandidatureAddTaxiRailyContractNotExistsError = DataLoadError<
  CandidatureAddErrorType.TAXI_RAILY_CONTRACT_NOT_VALID,
  {}
>;

export type CandidatureAddOrderNotExistsError = DataLoadError<
  CandidatureAddErrorType.ORDER_NOT_EXISTS,
  {}
>;

export type CandidatureAddOrderInProgressError = DataLoadError<
  CandidatureAddErrorType.ORDER_IN_PROGRESS,
  {}
>;

export type CandidatureAddPlanEntryCandidateCollisionError = DataLoadError<
  CandidatureAddErrorType.PLAN_ENTRY_CANDIDATE_COLLISION,
  {}
>;

type CandidatureAddError =
  | DataLoadDefaultErrors
  | CandidatureAddTaxiDriverAssociationNotExistsError
  | CandidatureAddTaxiDriverContractNotValidError
  | CandidatureAddTaxiRailyContractNotExistsError
  | CandidatureAddOrderNotExistsError
  | CandidatureAddOrderInProgressError
  | CandidatureAddPlanEntryCandidateCollisionError;

export default CandidatureAddError;
